import { IdTokenUser } from "@shared/http/id-token";
import TrackingService, {
  NullTrackingServiceAdapter,
  ProductionTrackingServiceAdapter,
} from "@shared/services/TrackingService";

class SherlockTrackingService extends TrackingService {
  identifyUser(user: IdTokenUser) {
    if (!user?.id) return;

    this.identify(user.id, user.name);

    // These are included with EVERY event automatically
    this.registerSuperProperties({
      "User Name": user.name,
      "Is Admin": user.admin,
    });

    // Set additional employee info for admin users (people properties only, not in events)
    if (user.admin) {
      this.setUserInfo({
        employee_region: user.employee_region,
        employee_type: user.employee_type,
      });
    }
  }
}

const trackingService = import.meta.env.VITE_MIXPANEL_ACCESS_TOKEN
  ? new SherlockTrackingService(new ProductionTrackingServiceAdapter(import.meta.env.VITE_MIXPANEL_ACCESS_TOKEN))
  : new SherlockTrackingService(new NullTrackingServiceAdapter());

export default trackingService;
